import { render, staticRenderFns } from "./template.html?vue&type=template&id=256ef792&external"
import script from "./controller.js?vue&type=script&lang=js&external"
export * from "./controller.js?vue&type=script&lang=js&external"
import style0 from "./styles.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports